import React from 'react';

import { Card, Typography } from 'antd';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';
import ProducerContact from './producerContact';
import RefundActions from './refundActions';

interface TicketProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const Ticket = ({ delivery, closeQuickView }: TicketProps) => {
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-start gap-3'>
        <img
          className='size-16 shrink-0 rounded bg-(--uizz-antd-color-fill-tertiary) object-cover'
          src={delivery.product.image}
          alt={delivery.product.title}
        />

        <div>
          <Typography.Text>{delivery.product.title}</Typography.Text>
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <Card title='Informações do evento'>
        <div className='flex flex-col gap-1'>
          <div className='text-sm'>
            <Typography.Text>Data: </Typography.Text>
            <Typography.Text type='secondary'>
              {delivery.product.event.date
                ? dateService.dateToString(new Date(delivery.product.event.date), 'dd/MM/yyyy')
                : '-'}
            </Typography.Text>
          </div>
          <div className='text-sm'>
            <Typography.Text>Horário: </Typography.Text>
            <Typography.Text type='secondary'>
              {delivery.product.event.date
                ? dateService.dateToString(new Date(delivery.product.event.date), 'H:mm')
                : '-'}
            </Typography.Text>
          </div>
          <div className='text-sm'>
            <Typography.Text>Endereço: </Typography.Text>
            <Typography.Text type='secondary'>
              {' ' + delivery.product.event.address.street + ', '}
              {delivery.product.event.address.number + ' - '}
              {delivery.product.event.address.neighborhood + ' - '}
              {delivery.product.event.address.city + ' - '}
              {delivery.product.event.address.state}
            </Typography.Text>
          </div>
        </div>
      </Card>

      {delivery?.producer.showProducerContactInformation && <ProducerContact delivery={delivery} />}

      {!delivery.unlimited_installment && !delivery?.bankslip_installments && <InvoiceDetails delivery={delivery} />}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <BankSlipInstallment delivery={delivery} />
      )}

      <RefundActions delivery={delivery} />

      {delivery.unlimited_installment && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}

      <GetCcbTerm delivery={delivery} />
    </div>
  );
};

export default Ticket;
